"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backoff = void 0;
const teslabot_1 = require("teslabot");
exports.backoff = (0, teslabot_1.createBackoff)({
    maxFailureCount: 5,
    onError: (e, i) => i > 3 && console.warn(e)
});
